import "../SystemSettings/SystemSettings.css"
import {
  uploadFile
} from "../../stores/actions/dashboardActions";
import { connect } from "react-redux";
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import React, {useState} from 'react';
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const DocumentationUpload = ({
  classes,
  systemId,
  mapUploadSuccessfully,
  mapUploadFailed,
  uploadFile,
  mapUploadProgress,
  failedUploadMapFile,
  resetMapFileUploadStatus,
  updateParent,
  mobileView,
  ...props
}) => {
  const handleSaveFile = (file) => {
    let formData = new FormData();
    formData.append("systemID", systemId);
    formData.append("mimeType", file.type);
    formData.append("fileSize", file.size);
    formData.append("fileName", file.name);
    formData.append("file", file);
    uploadFile(formData, systemId);
  }

  const formStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "20px",
    height: "42px",
    flexWrap: "wrap",
    transition: "0.5s"
  }

  const formStyleMobile = formStyle;
  formStyleMobile.justifyContent = "flex-start";

  const uploadButtonStyle = {
    backgroundColor: "#00acc1",
    color: "#fff",
    width: "190px",
    padding: "20px",
  }

  return (<>
            <div style={{ width:  "190px" }} data-testid="uploadWrapper">
              <label htmlFor="map-input">
                <input
                  type="file"
                  id="map-input"
                  onChange={e => handleSaveFile(e.target.files[0])}
                  style={{ display: "none" }}
                />
                <Fab
                  size="small"
                  component="span"
                  aria-label="add"
                  variant="extended"
                  style={uploadButtonStyle}
                  data-testid="uploadButton"
                >
                  <AddIcon style={{ transform: "translateX(-8px)" }} data-testid="addIcon" />New file
                </Fab>
              </label>
            </div>
          </>
  )
}

const mapStateToProps = state => ({
  mapUploadSuccessfully: state.installer.mapUploadSuccessfully,
  mapUploadFailed: state.installer.mapUploadFailed,
  mapUploadProgress: state.installer.mapUploadProgress,
  failedUploadMapFile: state.installer.failedUploadMapFile,
  systemUpdatedViaWebsiteAt: state.installer.systemUpdatedViaWebsiteAt,
  mobileView: state.dashboard.mobileView,
});
const actions = {
  uploadFile,
}

export default connect(mapStateToProps, actions)(withStyles(regularFormsStyle)(DocumentationUpload));